import { cache } from 'villus'

const cacheInstance = cache()

export default function () {
  return cacheInstance
}
